import { NgxSpinnerService } from 'ngx-spinner';
import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { RootService } from 'src/app/services/root/root.service';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';


@Component({
  selector: 'app-dialog',
  templateUrl: './dialog.component.html',
  styleUrls: ['./dialog.component.scss']
})
export class DialogComponent implements OnInit {
  changePasswordForm: FormGroup;
  constructor(private formBuilder: FormBuilder, private dialogRef: MatDialogRef<DialogComponent>,
    private snackBar: MatSnackBar, private spinner: NgxSpinnerService, private rootService: RootService) { }

  ngOnInit() {
    this.changePasswordForm = this.formBuilder.group({
      password: ['', Validators.required]
    });
  }

  onSubmit(obj: FormGroup) {
    this.spinner.show();

    if (obj.status === "INVALID") {
      this.spinner.hide();
      return this.showAlert("Campos Requeridos*", "cerrar");
    }
    return this.rootService.changePassword(obj.value.password).subscribe((response) => {
      console.log(response);
      this.dialogRef.close();
      this.spinner.hide()
      this.showAlert("Contraseña Guardada", "cerrar");
    }, (error) => {
      console.log(error);
      this.showAlert("Error al cambiar contraseña, vuelva a intentar", "Cerrar");
      this.spinner.hide()
    });
  }

  showAlert(message: string, action: string) {
    this.snackBar.open(message, action, {
      duration: 2000,
    });
  }

}
